import React from 'react';
import News from '../../components/News';

function index() {
    return (
        <>
            <News />
        </>
    );
}

export default  index;